<template>
  <div v-if="!isPrint">
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 사내 연락체계 -->
    <table-custom
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="사내 연락체계"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '직책', type: 'text' },
        { id: 'input3', title: '연락처', type: 'text' },
        { id: 'input4', title: '임무 및 역할', type: 'textarea' },
        { id: 'input5', title: '관련 웹사이트', type: 'link' },
      ]"
      :mobile="['input1']"
      v-model="form.inside"
    />

    <!-- 사외 연락체계 -->
    <table-custom
      class="mt-28px"
      :board="board"
      :is-print="isPrint"
      title="사외 연락체계"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '연락처', type: 'text' },
        { id: 'input3', title: '비고', type: 'text' },
        { id: 'input4', title: '임무 및 역할', type: 'textarea' },
        { id: 'input5', title: '관련 웹사이트', type: 'link' },
      ]"
      :mobile="['input1']"
      v-model="form.outside"
    />

    <!-- 파일첨부 -->
    <file-upload-module class="mt-28px" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
  <print v-else :form="form" />
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import Print from "./Print.vue";

export default {
  components: {
    FieldSelectModule,
    TableCustom,
    FileUploadModule,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inside: [
          { id: 1, input1: "안전보건관리책임자", input2: "", input3: "" },
          { id: 2, input1: "비상지휘단장", input2: "" },
          { id: 3, input1: "현장대응", input2: "안전관리자, 보건관리자" },
        ],
        outside: [
          { id: 1, input1: "경찰서", input2: "", input3: "" },
          { id: 2, input1: "소방서", input2: "", input3: "" },
          { id: 3, input1: "병원", input2: "", input3: "" },
          { id: 4, input1: "고용노동부", input2: "", input3: "" },
          { id: 5, input1: "한국가스공사", input2: "", input3: "" },
          { id: 6, input1: "한국전력공사", input2: "", input3: "" },
        ],
        fileList: [],
      },
    };
  },
};
</script>
